export const LOCALE = 'locale';

export const DEFAULT_LOCALE = 'uk';
export const FR_LOCALE = 'fr';
export const ES_LOCALE = 'es';
